import { progressUnionTypes } from './unionTypes';
import { competitionPlaceOptionList, meetupAttendeesOptionList, meetupTypesOptionList, prizeCategoryOptionList, jurisdictionOptionList } from './optionLists';
export var activityDictionary = {
  1: {
    title: 'bachelorDegree',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  2: {
    title: 'masterDegree',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  3: {
    title: 'diploma',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  4: {
    title: 'paddlGames',
    progressType: progressUnionTypes[0],
    isProgressDisabled: true
  },
  5: {
    title: 'course',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  6: {
    title: 'certificate',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  7: {
    title: 'highSchool',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  8: {
    title: 'internship',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  9: {
    title: 'casualWork',
    progressType: progressUnionTypes[1],
    isProgressDisabled: false
  },
  10: {
    title: 'fullTime',
    progressType: progressUnionTypes[1],
    isProgressDisabled: false
  },
  11: {
    title: 'partTime',
    progressType: progressUnionTypes[1],
    isProgressDisabled: false
  },
  12: {
    title: 'contract',
    progressType: progressUnionTypes[1],
    isProgressDisabled: false
  },
  13: {
    title: 'hackathon',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  14: {
    title: null,
    progressType: null,
    isProgressDisabled: false
  },
  // Use to exist - Needed for backward compatibility
  15: {
    title: null,
    progressType: null,
    isProgressDisabled: false
  },
  // Use to exist - Needed for backward compatibility
  16: {
    title: 'phd',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  17: {
    title: 'sideHustle',
    progressType: progressUnionTypes[1],
    isProgressDisabled: false
  },
  18: {
    title: 'volunteer',
    progressType: progressUnionTypes[1],
    isProgressDisabled: false
  },
  19: {
    title: 'prize',
    progressType: progressUnionTypes[2],
    isProgressDisabled: false
  },
  20: {
    title: 'membership',
    progressType: progressUnionTypes[1],
    isProgressDisabled: false
  },
  21: {
    title: 'meetup',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  22: {
    title: 'workshop',
    progressType: progressUnionTypes[0],
    isProgressDisabled: false
  },
  23: {
    title: 'video',
    progressType: progressUnionTypes[2],
    isProgressDisabled: false
  },
  24: {
    title: 'article',
    progressType: progressUnionTypes[2],
    isProgressDisabled: false
  }
};
export var getActivityDisplayName = function getActivityDisplayName(id) {
  var _activityDictionary$i;
  return ((_activityDictionary$i = activityDictionary[id]) === null || _activityDictionary$i === void 0 ? void 0 : _activityDictionary$i.title) || "display name not configured for activity id ".concat(id);
};
export var getActivityTitleByVariantId = function getActivityTitleByVariantId(id) {
  if (!id || !activityDictionary[id]) {
    throw new Error('getActivityTitleByVariantId function expects a valid argument');
  }
  return activityDictionary[id].title;
};
export var getVariantIdByActivityTitle = function getVariantIdByActivityTitle(title) {
  var associatedKey = Object.keys(activityDictionary).find(function (key) {
    return activityDictionary[key].title === title && key;
  });
  if (!title || !associatedKey) {
    throw new Error('getVariantIdByActivityTitle function expects a valid argument');
  }
  return associatedKey;
};
export var getActivityProgressTypeByVariantId = function getActivityProgressTypeByVariantId(id) {
  if (!id || !activityDictionary[id]) {
    throw new Error('getActivityProgressTypeByVariantId function expects a valid argument');
  }
  return activityDictionary[id].progressType;
};
export var getActivityIsProgressDisabledByVariantId = function getActivityIsProgressDisabledByVariantId(id) {
  if (!id || !activityDictionary[id]) {
    throw new Error('getActivityIsProgressDisabledByVariantId function expects a valid argument');
  }
  return activityDictionary[id].isProgressDisabled;
};
export var activityCategories = function activityCategories() {
  var cherryPick = function cherryPick(list) {
    return list.map(function (key) {
      return activityDictionary[key];
    });
  };
  return [{
    id: 'education',
    title: 'Education',
    categoryId: 1,
    description: 'Select a formal learning activity below to add to your experience.',
    activities: cherryPick([5, 6, 3, 1, 2, 7, 16, 22])
  }, {
    id: 'competition',
    title: 'Competition',
    categoryId: 2,
    description: 'Select a competitive activity type to add to your experience.',
    activities: cherryPick([13, 4, 19])
  }, {
    id: 'employment',
    title: 'Employment',
    categoryId: 3,
    description: 'Select a job type below to add to your experience.',
    activities: cherryPick([9, 11, 10, 8, 12, 17])
  }, {
    id: 'social',
    title: 'Social',
    categoryId: 4,
    description: 'Select a social activity to add to your experience.',
    activities: cherryPick([20, 21])
  }, {
    id: 'personal',
    title: 'Personal',
    categoryId: 5,
    description: '',
    activities: cherryPick([23, 24])
  }, {
    id: 'life',
    title: 'Life',
    categoryId: 6,
    description: 'Select a life activity to add to your experience.',
    activities: cherryPick([18])
  }];
};
export var getActivitiesByCategoryName = function getActivitiesByCategoryName(categoryName) {
  var activities = activityCategories().find(function (category) {
    return (category === null || category === void 0 ? void 0 : category.id) === categoryName;
  });
  if (!activities) throw new Error('getActivitiesByCategoryName function expects a valid Category Name argument');
  return activities;
};
export var getCategoryNameByVariantId = function getCategoryNameByVariantId(variantId) {
  var activityTitle = getActivityTitleByVariantId(variantId);
  var category = activityCategories().find(function (_ref) {
    var activities = _ref.activities;
    return activities.find(function (_ref2) {
      var title = _ref2.title;
      return title === activityTitle && activityTitle;
    });
  });
  if (!variantId) throw new Error('getCategoryNameByVariantId function expects a valid Variant ID argument');
  return category === null || category === void 0 ? void 0 : category.id;
};
export var getFieldValueByName = function getFieldValueByName(name, optionList) {
  var fieldValue = optionList.find(function (_ref3) {
    var value = _ref3.value;
    return value === name;
  });
  return fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.text;
};
export var getCompetitionPlaceByName = function getCompetitionPlaceByName(name) {
  var competitionPlace = competitionPlaceOptionList.find(function (_ref4) {
    var value = _ref4.value;
    return value === name;
  });
  return competitionPlace === null || competitionPlace === void 0 ? void 0 : competitionPlace.text;
};
export var getMeetupAttendeesByName = function getMeetupAttendeesByName(name) {
  var meetupAttendeesName = meetupAttendeesOptionList.find(function (_ref5) {
    var value = _ref5.value;
    return value === name;
  });
  return meetupAttendeesName === null || meetupAttendeesName === void 0 ? void 0 : meetupAttendeesName.text;
};
export var getMeetupTypesByName = function getMeetupTypesByName(name) {
  var meetupTypesName = meetupTypesOptionList.find(function (_ref6) {
    var value = _ref6.value;
    return value === name;
  });
  return meetupTypesName === null || meetupTypesName === void 0 ? void 0 : meetupTypesName.text;
};
export var getActivityDurationNumberOptionList = function getActivityDurationNumberOptionList() {
  var courseDurationNumberOptionList = [];
  for (var index = 0; index < 30; index += 1) {
    courseDurationNumberOptionList[index] = {
      value: index + 1,
      text: (index + 1).toString()
    };
  }
  return courseDurationNumberOptionList;
};
export var getCapitalizedText = function getCapitalizedText(text) {
  return text.charAt(0).toUpperCase() + text.toLowerCase().slice(1);
};
export var getCapitalizedComponentName = function getCapitalizedComponentName(componentName) {
  return componentName.charAt(0).toUpperCase() + componentName.slice(1);
};
export var getPrizeCategoryNameById = function getPrizeCategoryNameById(name) {
  var prizeCategoryName = prizeCategoryOptionList.find(function (_ref7) {
    var value = _ref7.value;
    return value === name;
  });
  return prizeCategoryName === null || prizeCategoryName === void 0 ? void 0 : prizeCategoryName.text;
};
export var getJurisdictionNameById = function getJurisdictionNameById(name) {
  var jurisdictionName = jurisdictionOptionList.find(function (_ref8) {
    var value = _ref8.value;
    return value === name;
  });
  return jurisdictionName === null || jurisdictionName === void 0 ? void 0 : jurisdictionName.text;
};
export var getDurationUnit = function getDurationUnit(unit, value) {
  switch (unit) {
    case 'MINUTE':
      return value > 1 ? 'Minutes' : 'Minute';
    case 'HOUR':
      return value > 1 ? 'Hours' : 'Hours';
    case 'DAY':
      return value > 1 ? 'Days' : 'Day';
    case 'WEEK':
      return value > 1 ? 'Weeks' : 'Week';
    case 'MONTH':
      return value > 1 ? 'Months' : 'Month';
    case 'YEAR':
      return value > 1 ? 'Years' : 'Year';
    default:
      return unit;
  }
};
export var getSkillCountByTimeline = function getSkillCountByTimeline(timeline) {
  return timeline.map(function (_ref9) {
    var skillsCount = _ref9.skillsCount;
    return skillsCount;
  }).reduce(function (accumulativeSum, sum) {
    return accumulativeSum + sum;
  }, 0);
};
export var getActivityName = function getActivityName(_ref10) {
  var _ref10$name = _ref10.name,
    name = _ref10$name === void 0 ? undefined : _ref10$name,
    _ref10$role = _ref10.role,
    role = _ref10$role === void 0 ? {} : _ref10$role,
    _ref10$course = _ref10.course,
    course = _ref10$course === void 0 ? {} : _ref10$course,
    _ref10$issuer = _ref10.issuer,
    issuer = _ref10$issuer === void 0 ? {} : _ref10$issuer,
    _ref10$certificate = _ref10.certificate,
    certificate = _ref10$certificate === void 0 ? {} : _ref10$certificate,
    _ref10$event = _ref10.event,
    event = _ref10$event === void 0 ? {} : _ref10$event,
    _ref10$school = _ref10.school,
    school = _ref10$school === void 0 ? {} : _ref10$school,
    _ref10$title = _ref10.title,
    title = _ref10$title === void 0 ? undefined : _ref10$title,
    _ref10$session = _ref10.session,
    session = _ref10$session === void 0 ? {} : _ref10$session;
  return name || (title === null || title === void 0 ? void 0 : title.name) || title || (role === null || role === void 0 ? void 0 : role.name) || (course === null || course === void 0 ? void 0 : course.name) || (issuer === null || issuer === void 0 ? void 0 : issuer.name) || (certificate === null || certificate === void 0 ? void 0 : certificate.name) || (event === null || event === void 0 ? void 0 : event.name) || (school === null || school === void 0 ? void 0 : school.name) || (title === null || title === void 0 ? void 0 : title.name) || (session === null || session === void 0 ? void 0 : session.name) || undefined;
};
export var getOrganisationName = function getOrganisationName(_ref11) {
  var educator = _ref11.educator,
    trainer = _ref11.trainer,
    authority = _ref11.authority,
    school = _ref11.school,
    employer = _ref11.employer,
    organiser = _ref11.organiser,
    organisation = _ref11.organisation,
    issuer = _ref11.issuer,
    provider = _ref11.provider;
  return (educator === null || educator === void 0 ? void 0 : educator.name) || (trainer === null || trainer === void 0 ? void 0 : trainer.name) || (authority === null || authority === void 0 ? void 0 : authority.name) || (school === null || school === void 0 ? void 0 : school.name) || (employer === null || employer === void 0 ? void 0 : employer.name) || (organiser === null || organiser === void 0 ? void 0 : organiser.name) || (organisation === null || organisation === void 0 ? void 0 : organisation.name) || (issuer === null || issuer === void 0 ? void 0 : issuer.name) || (provider === null || provider === void 0 ? void 0 : provider.name) || undefined;
};